export const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.slice(1)

// 1234567.891 -> '1,234,567.891'; decimals are left untouched
export const groupThousands = (value?: string | number): string => {
    if (value === undefined || value === null || value === '') return ''
    const [integer, decimals] = String(value).split('.')
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return decimals === undefined ? grouped : `${grouped}.${decimals}`
}

export const timeAgo = (timestamp: number, now = Date.now()): string => {
    const minutes = Math.floor((now - timestamp) / 60000)
    if (minutes < 1) return 'just now'
    if (minutes < 60) return `${minutes}m ago`
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return `${hours}h ago`
    return `${Math.floor(hours / 24)}d ago`
}
